import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

const StyledTableRow = styled(TableRow)(({ theme, selected }) => ({
  transition: 'background-color 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    '& .MuiTypography-root': {
      color: theme.palette.text.primary,
    },
  },
  ...(selected && {
    backgroundColor: theme.palette.action.selected,
    '& .MuiTypography-root': {
      color: theme.palette.text.primary,
    },
  }),
}));

function ProductExpandableTable({ columns, rows, renderRowSubComponent }) {
  const theme = useTheme();
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableBody>
          {rows.map((row, index) => (
            <React.Fragment key={row.id || index}>
              <StyledTableRow key={row.id || index} onClick={row.onClick} selected={row.selected}>
                {columns.map((column, colIndex) => (
                  <TableCell key={colIndex} align={column.align || 'left'} style={{ width: column.width }}>
                    {column.name === 'actions' ? row.actions : row[column.name]}
                  </TableCell>
                ))}
              </StyledTableRow>
              {renderRowSubComponent && renderRowSubComponent({ row })}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ProductExpandableTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  renderRowSubComponent: PropTypes.func,
};

export default ProductExpandableTable;
